import axios from 'axios';
const Token = JSON.parse(localStorage.getItem("token"))


export const SalaryLists = async (page, pageSize) =>
     await axios.get(process.env.REACT_APP_API_URL + `/salary/?page=${page}&size=${pageSize}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const FindOne = async (id) =>
    await axios.get(process.env.REACT_APP_API_URL + '/salary/' + id, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        }
    })

export const SalarySearchLists = async (data, page, pageSize) =>     
    await axios({
        method: 'POST',
        url: process.env.REACT_APP_API_URL + `/salary/?page=${page}&size=${pageSize}`,
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-type": "Application/json",
            "Authorization": `Bearer ${Token.access_token}`
        },
        data: {
            t_year: data.t_year,
        }
    }
    )

// export const SalarySlipLists = async (page, pageSize) =>
//     await axios.get(process.env.REACT_APP_API_URL + `/salaryslip/?page=${page}&size=${pageSize}`, {
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         }
//     })


// export const SalarySlipSearchLists = async (data, page, pageSize) =>     
//     await axios({
//         method: 'POST',
//         url: process.env.REACT_APP_API_URL + `/salaryslip/?page=${page}&size=${pageSize}`,
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         },
//         data: {
//             t_year: data.t_year,
//         }
//     }
//     )

// export const FindOne = async (id) =>
//     await axios.get(process.env.REACT_APP_API_URL + '/salaryslip/' + id, {
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         }
//     })

// export const viewFiles = async (id) =>
//     await axios.get(process.env.REACT_APP_API_URL + '/salaryslip/view/' + id, {
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         }
       
//     })


// export const downloadFilesAPI = async (id) =>
//     await axios.get(process.env.REACT_APP_API_URL + '/salaryslip/download/files/' + id, {
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-type": "Application/json",
//             "Authorization": `Bearer ${Token.access_token}`
//         },
//         responseType: 'blob'
//     })



